import React from 'react'
import { graphql } from 'gatsby'
import get from 'lodash/get'
import Helmet from 'react-helmet'
import Hero from '../components/hero'
import Layout from '../components/layout'
import ArticlePreview from '../components/article-preview'
import About from '../components/about'
import Classes from '../components/classes'

class RootIndex extends React.Component {
  render() {
    const siteTitle = get(this, 'props.data.site.siteMetadata.title')
    const posts = get(this, 'props.data.allContentfulBlogPost.edges')
    const image = get(this, 'props.data.allImageSharp.edges')

    return (
      <Layout location={this.props.location}>
        <div>
          <Helmet title={siteTitle}>
            <meta
              name="description"
              content="Aberystwyth Gymnastics Club is West Wales' best gymnastics club for members of all ages"
            />
          </Helmet>
          <Hero data={image[8]} title={siteTitle} />
          <Classes classes={posts} />
          <About image1={image[5]} image2={image[9]} />
        </div>
      </Layout>
    )
  }
}

export default RootIndex

export const pageQuery = graphql`
  query HomeQuery {
    site {
      siteMetadata {
        title
      }
    }
    allContentfulBlogPost(sort: { fields: [publishDate], order: ASC }) {
      edges {
        node {
          title
          slug
          publishDate(formatString: "MMMM Do, YYYY")
          tags
          description {
            childMarkdownRemark {
              html
            }
          }
        }
      }
    }
    allImageSharp {
      edges {
        node {
          id
          fluid(maxHeight: 1440, maxWidth: 1920) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  }
`
